import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type HoverPromptProps = {
  text: string;
  opacity: 0 | 1;
};

export const HoverPrompt: React.FunctionComponent<HoverPromptProps> = ({ text, opacity }) => (
  <Box
    className="hover-prompt"
    sx={{
      position: 'absolute',
      top: '-52px',
      right: '12px',
      opacity,
      transition: 'opacity 300ms ease-in-out 400ms',
      whiteSpace: 'wrap',
    }}
  >
    <Typography
      variant="caption"
      color="primary.main"
      minHeight="58px"
      width="190px"
      textAlign="center"
      position="relative"
      borderRadius="8px"
      padding="12px"
      sx={(theme) => ({
        fontFamily: 'Inter',
        backgroundColor: theme.palette.primary.contrastText,
        boxShadow: `0 2px 12px 0 ${theme.palette.myShadow.hoverPrompt}`,
        display: 'flex',
      })}
    >
      {text}
      <Box
        sx={{
          position: 'absolute',
          bottom: '-12px',
          right: 'calc(50% - 4px)',
          width: '0px',
          height: '0px',
          borderLeft: '4px solid transparent',
          borderRight: '4px solid transparent',
          borderTop: (theme) => `12px solid ${theme.palette.primary.contrastText}`,
        }}
      />
    </Typography>
  </Box>
);
